<script lang="ts">
import { WorkInProgress } from "./work-in-progress.ts";
export default WorkInProgress;
</script>
<template>
    <base-header type="white"></base-header>
    <main class="p-d-flex p-flex-column">
        <div class="p-d-flex p-jc-center under-construction--img-container">
            <img src="/img/under-construction.svg" class="under-construction--img" />
        </div>
        <div class="p-d-flex p-jc-center under-construction--text-container">
            <div class="under-construction--text">
                <i18n-t keypath="common.workingInProgress" />
            </div>
        </div>
        <div class="p-d-flex p-jc-center under-construction--text-second-container">
            <div class="under-construction--text-second">
                <i18n-t keypath="common.underConstruction" />
            </div>
        </div>
    </main>
    <base-footer is-work-in-progress-page="true"></base-footer>
</template>
<style scoped>
.under-construction--img-container {
    margin-top: 90px;
}

.under-construction--img {
    height: 120px;
    width: calc(min(100vw, 412px));
}

.under-construction--text-container {
    margin-top: 10px;
}

.under-construction--text {
    font-family: var(--font-family);
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: 0.01em;
    text-align: center;
    color: #283747;
}

.layout__footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 10;
    padding: 10px;
    margin-top: 10px;
}

.under-construction--text-second {
    font-family: var(--font-family);
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
    color: #627690;
}

.under-construction--text-second-container {
    margin-top: 0px;
}
</style>
